// extracted by mini-css-extract-plugin
export default {"card":"DqakU","header":"thSDs","buttons":"cCwWt","loop":"x6c1D","playbutton":"HLt4T"};